import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class MasterDataManageService {
  // 获取主数据列表
  static async getList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataMainType?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增主数据类型
  static async createMasterDataType(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/DataMainType', payload))
    return Callback(err, res)
  }
  // 编辑主数据类型
  static async editMasterDataType(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/DataMainType/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  // 删除主数据类型
  static async deleteMasterDataType(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/DataMainType/many', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 导出主数据类型
  static async exportMasterDataType(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataMainType/export', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 获取主数据清单子列表
  static async getmasterDataList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/query?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 导出主数据清单子列表
  static async exportMasterDetailList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/export${payload.urlParam}`, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 获取主数据分发列表
  static async getMasterDistributeList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataMainDispatcher?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 生成API
  static async createNewAPI(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataMainDispatcher/create-api', payload)
    )
    return Callback(err, res)
  }
  // 新增分发配置
  static async createDistributeConfig(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/DataMainDispatcher', payload))
    return Callback(err, res)
  }
  // 编辑分发配置
  static async editDistributeConfig(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/DataMainDispatcher/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  // 删除分发配置
  static async deleteDistributeConfig(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/DataMainDispatcher/many', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  static async exportDistributeList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataMainDispatcher/export', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 根据classId获取资产目录树名称
  static async listByClassIds(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StructureBreakdown/list-by-classids', payload)
    )
    return Callback(err, res)
  }
}
